import { Route, RouteObject } from "react-router-dom";
import { orgSetupRoutes } from "./org-setup";
import { utilitySetupRoutes } from "./utility-setup";
import { dataMigrationRoutes } from "./data-migration";
import { systemAdminRoutes } from "./system-admin";
import { subscriptionRoutes } from "./subscription/routes";

export interface OnboardingRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: OnboardingRoute[];
}
export const onboardingRoute: OnboardingRoute[] = [
  ...systemAdminRoutes,
  ...orgSetupRoutes,
  ...subscriptionRoutes,
  ...utilitySetupRoutes,
  ...dataMigrationRoutes,
];
